import type { NormalizedBBox } from 'features/knowledgeDocumentViewer/types/ocrViewer'

export type RegionFraming = {
  viewportFill: number
  minRegionPageFraction: number
}

export const CONTEXT_FRAMING: RegionFraming = {
  viewportFill: 0.3,
  minRegionPageFraction: 0.12,
}

export const CITED_TEXT_FRAMING: RegionFraming = {
  viewportFill: 0.85,
  minRegionPageFraction: 0.35,
}

type Size = { w: number; h: number }

export function framedRegionScale(
  bbox: NormalizedBBox,
  pageAtScaleOne: Size,
  viewport: Size,
  framing: RegionFraming
): number {
  const regionW = Math.max(
    Math.max(bbox.width, framing.minRegionPageFraction) * pageAtScaleOne.w,
    1
  )
  const regionH = Math.max(
    Math.max(bbox.height, framing.minRegionPageFraction) * pageAtScaleOne.h,
    1
  )
  return Math.min(
    (framing.viewportFill * viewport.w) / regionW,
    (framing.viewportFill * viewport.h) / regionH
  )
}
